// extracted by mini-css-extract-plugin
module.exports = {"button":"_40d5d0e87d--button--L1vG_"};